var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "form-overlay select-mention", class: _vm.position },
    [
      _c("div", { staticClass: "steep1" }, [
        _c("div", { staticClass: "nav-network hide-scrollbar" }, [
          !_vm.networks || _vm.networks.length > 1
            ? _c("div", { staticClass: "list-item-network" }, [
                this.pagesSelected.find((p) => p.network == "facebook") &&
                (!_vm.networks || _vm.networks.includes("facebook"))
                  ? _c(
                      "div",
                      {
                        staticClass: "item-network",
                        class: { active: _vm.networkSelected == "facebook" },
                        on: { click: () => _vm.selectNetwork("facebook") },
                      },
                      [_c("i", { staticClass: "fa-brands fa-facebook" })]
                    )
                  : _vm._e(),
                this.pagesSelected.find((p) => p.network == "instagram") &&
                (!_vm.networks || _vm.networks.includes("instagram"))
                  ? _c(
                      "div",
                      {
                        staticClass: "item-network",
                        class: { active: _vm.networkSelected == "instagram" },
                        on: { click: () => _vm.selectNetwork("instagram") },
                      },
                      [_c("i", { staticClass: "fa-brands fa-instagram" })]
                    )
                  : _vm._e(),
                this.pagesSelected.find((p) => p.network == "linkedin") &&
                (!_vm.networks || _vm.networks.includes("linkedin"))
                  ? _c(
                      "div",
                      {
                        staticClass: "item-network",
                        class: { active: _vm.networkSelected == "linkedin" },
                        on: { click: () => _vm.selectNetwork("linkedin") },
                      },
                      [_c("i", { staticClass: "fa-brands fa-linkedin" })]
                    )
                  : _vm._e(),
                this.pagesSelected.find((p) => p.network == "twitter") &&
                (!_vm.networks || _vm.networks.includes("twitter"))
                  ? _c(
                      "div",
                      {
                        staticClass: "item-network",
                        class: { active: _vm.networkSelected == "twitter" },
                        on: { click: () => _vm.selectNetwork("twitter") },
                      },
                      [_c("i", { staticClass: "fa-brands fa-twitter" })]
                    )
                  : _vm._e(),
                this.pagesSelected.find((p) => p.network == "bluesky") &&
                (!_vm.networks || _vm.networks.includes("bluesky"))
                  ? _c(
                      "div",
                      {
                        staticClass: "item-network bluesky",
                        class: { active: _vm.networkSelected == "bluesky" },
                        on: { click: () => _vm.selectNetwork("bluesky") },
                      },
                      [
                        _c(
                          "svg",
                          {
                            attrs: {
                              xmlns: "http://www.w3.org/2000/svg",
                              viewBox: "0 0 640 640",
                            },
                          },
                          [
                            _c("path", {
                              attrs: {
                                d: "M439.8 358.7C436.5 358.3 433.1 357.9 429.8 357.4C433.2 357.8 436.5 358.3 439.8 358.7zM320 291.1C293.9 240.4 222.9 145.9 156.9 99.3C93.6 54.6 69.5 62.3 53.6 69.5C35.3 77.8 32 105.9 32 122.4C32 138.9 41.1 258 47 277.9C66.5 343.6 136.1 365.8 200.2 358.6C203.5 358.1 206.8 357.7 210.2 357.2C206.9 357.7 203.6 358.2 200.2 358.6C106.3 372.6 22.9 406.8 132.3 528.5C252.6 653.1 297.1 501.8 320 425.1C342.9 501.8 369.2 647.6 505.6 528.5C608 425.1 533.7 372.5 439.8 358.6C436.5 358.2 433.1 357.8 429.8 357.3C433.2 357.7 436.5 358.2 439.8 358.6C503.9 365.7 573.4 343.5 593 277.9C598.9 258 608 139 608 122.4C608 105.8 604.7 77.7 586.4 69.5C570.6 62.4 546.4 54.6 483.2 99.3C417.1 145.9 346.1 240.4 320 291.1z",
                              },
                            }),
                          ]
                        ),
                      ]
                    )
                  : _vm._e(),
                this.pagesSelected.find(
                  (p) =>
                    p.network == "tiktok" &&
                    ((p.story_config && p.story_config.created) || p.bot_status)
                ) &&
                (!_vm.networks || _vm.networks.includes("tiktok"))
                  ? _c(
                      "div",
                      {
                        staticClass: "item-network",
                        class: { active: _vm.networkSelected == "tiktok" },
                        on: { click: () => _vm.selectNetwork("tiktok") },
                      },
                      [_c("i", { staticClass: "fa-brands fa-tiktok" })]
                    )
                  : _vm._e(),
              ])
            : _vm._e(),
        ]),
        _c("div", { staticClass: "content searchMention" }, [
          _c("div", { staticClass: "input" }, [
            _c("i", { staticClass: "fa-regular fa-magnifying-glass" }),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.textSearch,
                  expression: "textSearch",
                },
              ],
              ref: "inputSearch",
              attrs: { placeholder: _vm.textPlaceholder },
              domProps: { value: _vm.textSearch },
              on: {
                keyup: function ($event) {
                  if (
                    !$event.type.indexOf("key") &&
                    _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                  )
                    return null
                  return _vm.sendSearchMention.apply(null, arguments)
                },
                input: function ($event) {
                  if ($event.target.composing) return
                  _vm.textSearch = $event.target.value
                },
              },
            }),
          ]),
          _c(
            "div",
            { staticClass: "list-item list-chosen-item hide-scrollbar" },
            [
              _vm.mentionData.mention &&
              _vm.mentionData.mention[_vm.networkSelected]
                ? _c("div", { staticClass: "item chosen-item" }, [
                    _c("div", { staticClass: "image" }, [
                      _c("img", {
                        attrs: {
                          src: _vm.mentionData.mention[_vm.networkSelected]
                            .image
                            ? _vm.mentionData.mention[_vm.networkSelected].image
                            : _vm.saveUrlPictureUser[
                                _vm.mentionData.mention[_vm.networkSelected].id
                              ]
                            ? _vm.saveUrlPictureUser[
                                _vm.mentionData.mention[_vm.networkSelected].id
                              ]
                            : "img/avatar.jpg",
                          alt: "",
                        },
                      }),
                      _c("i", { staticClass: "fa-solid fa-check" }),
                    ]),
                    _c("div", { staticClass: "info" }, [
                      _c("p", { staticClass: "username" }, [
                        _vm._v(
                          _vm._s(
                            _vm.getUsername(
                              _vm.mentionData.mention[_vm.networkSelected]
                            )
                          )
                        ),
                      ]),
                      _c("p", { staticClass: "name" }, [
                        _vm._v(
                          _vm._s(
                            _vm.getSubName(
                              _vm.mentionData.mention[_vm.networkSelected]
                            )
                          )
                        ),
                      ]),
                    ]),
                    _c("i", {
                      staticClass: "fa-regular fa-xmark",
                      on: {
                        click: function ($event) {
                          return _vm.handleRemoveMention(_vm.networkSelected)
                        },
                      },
                    }),
                  ])
                : _vm._e(),
            ]
          ),
          _c(
            "div",
            { staticClass: "list-item hide-scrollbar" },
            [
              _vm.countMentionPerNetwork[_vm.networkSelected] >=
              _vm.maxMentionByNetwork[_vm.networkSelected]
                ? _c("p", { staticClass: "no-result" }, [
                    _vm._v(
                      _vm._s(_vm.$t("dash.post-creator.overlay.max-mentions"))
                    ),
                  ])
                : _vm.stateLoader
                ? _c("span", { staticClass: "loader" })
                : _vm.listPersonsAvailableComputed.length
                ? _vm._l(_vm.listPersonsAvailableComputed, function (person) {
                    return _c(
                      "div",
                      {
                        key: person.id,
                        staticClass: "item",
                        on: {
                          click: function ($event) {
                            return _vm.selectMention(person)
                          },
                        },
                      },
                      [
                        _c("img", {
                          attrs: { src: _vm.getPicture(person), alt: "" },
                        }),
                        _c("div", { staticClass: "info" }, [
                          _c("p", { staticClass: "username" }, [
                            _vm._v(_vm._s(_vm.getUsername(person))),
                          ]),
                          _c("p", { staticClass: "name" }, [
                            _vm._v(_vm._s(_vm.getSubName(person))),
                          ]),
                        ]),
                      ]
                    )
                  })
                : _vm.textSearch
                ? [
                    _vm.mentionData.mention &&
                    _vm.mentionData.mention[_vm.networkSelected]
                      ? _c("p", { staticClass: "no-result" }, [
                          _vm._v(
                            _vm._s(
                              _vm.$t(
                                "dash.post-creator.overlay.no-other-account"
                              )
                            )
                          ),
                        ])
                      : _c("p", { staticClass: "no-result" }, [
                          _vm._v(
                            _vm._s(
                              _vm.$t("dash.post-creator.overlay.no-account")
                            )
                          ),
                        ]),
                  ]
                : _vm._e(),
            ],
            2
          ),
        ]),
      ]),
      _vm.steep == 1
        ? _c(
            "div",
            { staticClass: "btn-secondary", on: { click: _vm.handleClose } },
            [_vm._v(_vm._s(_vm.$t("dash.button.close")))]
          )
        : _c(
            "div",
            {
              staticClass: "btn-secondary",
              on: {
                click: function ($event) {
                  _vm.steep = 1
                },
              },
            },
            [_vm._v(_vm._s(_vm.$t("dash.button.go_back")))]
          ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }